(function () {
  'use strict';

  const finder = document.getElementById('lf-finder');
  if (!finder) return;

  /* ── State ──────────────────────────────────────────────────── */
  let currentStep    = 1;
  let selectedStyle  = null;   // { title, imageUrlMobile }
  let likedMoods     = [];     // string[]
  let selectedScope  = null;   // { title, imageUrlMobile }
  let selectedBudget = null;   // number (€)
  let selectedIndoor = null;   // { label, collection }
  let selectedOutdoor= null;   // { label, collection }
  let firstMoodHintShowTimer = null;
  let firstMoodHintHideTimer = null;
  let firstMoodHintWrap = null;
  let firstMoodHintDismissHandler = null;

  const FIRST_MOOD_HINT_DELAY_MS = 1000;
  const FIRST_MOOD_HINT_DURATION_MS = 10000;

  /* ── DOM refs ───────────────────────────────────────────────── */
  const backBtn       = finder.querySelector('#lf-back-btn');
  const brand         = finder.querySelector('#lf-brand');
  const progressLabel = finder.querySelector('#lf-progress-label');
  const progressPct   = finder.querySelector('#lf-progress-pct');
  const progressFill  = finder.querySelector('#lf-progress-fill');
  const content       = finder.querySelector('#lf-content');
  const allSteps      = Array.from(finder.querySelectorAll('.lf-step'));

  /* ── Helpers ────────────────────────────────────────────────── */
  function getStep(n) {
    return allSteps.find(s => +s.dataset.step === n) || null;
  }

  function setProgress(pct) {
    const p = Math.max(0, Math.min(100, Math.round(pct)));
    progressPct.textContent  = p + '%';
    progressFill.style.width = p + '%';
  }

  function setProgressLabel(text) {
    progressLabel.textContent = text;
  }

  function hideFirstMoodHint() {
    if (firstMoodHintHideTimer) {
      clearTimeout(firstMoodHintHideTimer);
      firstMoodHintHideTimer = null;
    }
    if (firstMoodHintWrap && firstMoodHintDismissHandler) {
      firstMoodHintWrap.removeEventListener('click', firstMoodHintDismissHandler);
    }
    if (firstMoodHintWrap) {
      firstMoodHintWrap.classList.remove('is-showing-hint');
      const hint = firstMoodHintWrap.querySelector('.lf-swipe-hint');
      if (hint) hint.classList.remove('is-visible');
      const stepEl = firstMoodHintWrap.closest('.lf-step');
      stepEl?.querySelectorAll('.lf-mood-btn').forEach(b => (b.disabled = false));
    }
    firstMoodHintWrap = null;
    firstMoodHintDismissHandler = null;
  }

  function clearFirstMoodHintState() {
    if (firstMoodHintShowTimer) {
      clearTimeout(firstMoodHintShowTimer);
      firstMoodHintShowTimer = null;
    }
    hideFirstMoodHint();
  }

  function showFirstMoodHint(wrap) {
    const hint = wrap?.querySelector('.lf-swipe-hint');
    if (!hint || !wrap) return;

    firstMoodHintWrap = wrap;
    wrap.classList.add('is-showing-hint');
    hint.classList.add('is-visible');

    const stepEl = wrap.closest('.lf-step');
    stepEl?.querySelectorAll('.lf-mood-btn').forEach(b => (b.disabled = true));

    firstMoodHintDismissHandler = () => hideFirstMoodHint();
    wrap.addEventListener('click', firstMoodHintDismissHandler, { once: true });
    firstMoodHintHideTimer = setTimeout(hideFirstMoodHint, FIRST_MOOD_HINT_DURATION_MS);
  }

  function scheduleFirstMoodHint(stepEl) {
    const wrap = stepEl.querySelector('.lf-mood-wrap[data-first-mood="true"]');
    if (!wrap?.querySelector('.lf-swipe-hint')) return;

    firstMoodHintShowTimer = setTimeout(() => {
      firstMoodHintShowTimer = null;
      showFirstMoodHint(wrap);
    }, FIRST_MOOD_HINT_DELAY_MS);
  }

  /* Toggle the budget CTA between its two text states */
  function enableCta(stepEl, enabled) {
    const cta = stepEl.querySelector('[data-action="next"]');
    if (!cta) return;
    cta.classList.toggle('is-disabled', !enabled);
    const pre = cta.querySelector('.lf-cta__pre');
    const go  = cta.querySelector('.lf-cta__go');
    if (pre) pre.style.display = enabled ? 'none' : '';
    if (go)  go.style.display  = enabled ? ''     : 'none';
  }

  /* ── Navigation ─────────────────────────────────────────────── */
  function showStep(n) {
    const prevEl = getStep(currentStep);
    const nextEl = getStep(n);
    if (!nextEl) return;

    clearFirstMoodHintState();
    prevEl?.classList.remove('is-active');
    nextEl.classList.add('is-active');
    currentStep = n;
    content.scrollTo({ top: 0, behavior: 'smooth' });
    onEnter(nextEl);
  }

  function goNext() { showStep(currentStep + 1); }

  function goBack() {
    const stepEl = getStep(currentStep);
    if (stepEl?.dataset.stepType === 'analysis') {
      showStep(1);
      return;
    }
    if (currentStep > 1) showStep(currentStep - 1);
    else window.history.back();
  }

  /* ── Step-enter logic ───────────────────────────────────────── */
  function onEnter(stepEl) {
    const type = stepEl.dataset.stepType;
    const showBrandOnly = type === 'profile';

    /* Header state: profile shows logo; analysis + earlier steps show zurück */
    if (backBtn) backBtn.style.display = showBrandOnly ? 'none' : '';
    if (brand)   brand.style.display   = showBrandOnly ? 'block' : 'none';

    switch (type) {

      case 'style':
        setProgressLabel('Dein Lichtprofil');
        setProgress(0);
        break;

      case 'mood':
        setProgressLabel('Dein Lichtprofil');
        setProgress(+stepEl.dataset.progress || 0);
        stepEl.querySelectorAll('.lf-mood-btn').forEach(b => (b.disabled = false));
        stepEl.querySelectorAll('.lf-mood-wrap').forEach(wrap => {
          wrap.classList.remove('is-showing-hint');
          const hint = wrap.querySelector('.lf-swipe-hint');
          if (hint) hint.classList.remove('is-visible');
        });
        scheduleFirstMoodHint(stepEl);
        break;

      case 'budget': {
        setProgressLabel('Dein Lichtprofil');
        /* Initialise slider to stored budget or its max */
        const slider = stepEl.querySelector('.lf-price-slider');
        const valEl  = stepEl.querySelector('#lf-price-current');
        if (slider) {
          const val = selectedBudget != null ? selectedBudget : +slider.min;
          slider.value = val;
          if (valEl) valEl.textContent = val + '€';
          updateSliderTrack(slider);
        }
        /* Restore scope card selection */
        if (selectedScope) {
          stepEl.querySelectorAll('.lf-scope-card').forEach(c =>
            c.classList.toggle('is-selected', c.dataset.value === selectedScope.title)
          );
          setProgress(+(stepEl.dataset.progressComplete || 90));
          enableCta(stepEl, true);
        } else {
          setProgress(+stepEl.dataset.progress || 70);
        }
        break;
      }

      case 'light_type': {
        setProgressLabel('Dein Lichtprofil');
        /* Restore selections */
        stepEl.querySelectorAll('.lf-lt-option').forEach(o => o.classList.remove('is-selected'));
        if (selectedIndoor) {
          stepEl.querySelectorAll('.lf-lt-option[data-group="indoor"]').forEach(o =>
            o.classList.toggle('is-selected', o.dataset.value === selectedIndoor.label)
          );
        }
        if (selectedOutdoor) {
          stepEl.querySelectorAll('.lf-lt-option[data-group="outdoor"]').forEach(o =>
            o.classList.toggle('is-selected', o.dataset.value === selectedOutdoor.label)
          );
        }
        if (selectedIndoor || selectedOutdoor) {
          setProgress(+(stepEl.dataset.progressComplete || 95));
        } else {
          setProgress(+stepEl.dataset.progress || 90);
        }
        // Step 9 is optional: user may continue without selecting a category.
        enableCta(stepEl, true);
        break;
      }

      case 'profile':
        setProgressLabel('Dein Lichtprofil');
        setProgress(100);
        populateProfile();
        break;

      case 'analysis': {
        const cfg = stepEl.querySelector('.lf-analysis-config');
        const analysisLabel = cfg?.dataset.analysisLabel || 'Analyse Lichtprofil';
        setProgressLabel(analysisLabel);
        setProgress(0);
        runAnalysis(stepEl);
        break;
      }
    }
  }

  /* ── Profile population ─────────────────────────────────────── */
  function populateProfile() {
    const byId = id => finder.querySelector('#' + id);

    /* Images from selected cards */
    const styleImgEl = byId('lf-pimg-style');
    const scopeImgEl = byId('lf-pimg-scope');
    if (styleImgEl && selectedStyle?.imageUrlMobile) {
      styleImgEl.style.backgroundImage = `url("${selectedStyle.imageUrlMobile}")`;
    }
    if (scopeImgEl && selectedScope?.imageUrlMobile) {
      scopeImgEl.style.backgroundImage = `url("${selectedScope.imageUrlMobile}")`;
    }

    /* Text values */
    const set = (id, val) => {
      const el = byId(id);
      if (el) el.textContent = val || '—';
    };
    set('lf-rv-style',   selectedStyle?.title);
    set('lf-rv-scope',   selectedScope?.title);
    set('lf-rv-indoor',  selectedIndoor?.label);
    set('lf-rv-outdoor', selectedOutdoor?.label);
    if (selectedBudget) set('lf-rv-budget', 'Bis ' + selectedBudget + '€');

    /* Liked moods — one per line */
    const moodEl = byId('lf-rv-mood');
    if (moodEl) {
      moodEl.innerHTML = likedMoods.length
        ? likedMoods.map(m => `<div>${m}</div>`).join('')
        : '<div>—</div>';
    }
  }

  /* ── Analysis animation ─────────────────────────────────────── */
  function runAnalysis(stepEl) {
    const analysisPhase = stepEl.querySelector('[data-phase="analysis"]');
    const resultsPhase  = stepEl.querySelector('[data-phase="results"]');
    const rows          = stepEl.querySelectorAll('.lf-a-row');
    const cfg           = stepEl.querySelector('.lf-analysis-config');
    const completeLabel = cfg?.dataset.completeLabel || 'Analyse abgeschlossen';

    /* Show analysis phase, hide results */
    if (analysisPhase) analysisPhase.style.display = '';
    if (resultsPhase)  resultsPhase.style.display  = 'none';

    /* Reset all rows */
    rows.forEach(row => {
      row.classList.remove('is-done');
      const fill = row.querySelector('.lf-a-fill');
      const pct  = row.querySelector('.lf-a-row__pct');
      const chk  = row.querySelector('.lf-a-row__check');
      const trk  = row.querySelector('.lf-a-track');
      if (fill) fill.style.width      = '0%';
      if (pct)  { pct.textContent = '0%'; pct.style.display = ''; }
      // if (chk)  chk.style.display     = 'none';
      // if (trk)  trk.style.display     = '';
    });

    const FILL_DURATION = 900;   // ms for each bar to fill
    const ROW_GAP       = 1100;  // ms between row starts

    rows.forEach((row, i) => {
      const fill = row.querySelector('.lf-a-fill');
      const pct  = row.querySelector('.lf-a-row__pct');
      const chk  = row.querySelector('.lf-a-row__check');
      const trk  = row.querySelector('.lf-a-track');

      setTimeout(() => {
        let startTs = null;

        const tick = (ts) => {
          if (!startTs) startTs = ts;
          const elapsed  = ts - startTs;
          const progress = Math.min(elapsed / FILL_DURATION, 1);
          const p        = Math.round(progress * 100);

          if (fill) fill.style.width   = p + '%';
          if (pct)  pct.textContent    = p + '%';

          /* Drive the global progress bar as a fraction of total rows */
          setProgress(((i + progress) / rows.length) * 100);

          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            /* Row complete */
            row.classList.add('is-done');
            if (pct) pct.style.display = 'none';
            // if (chk) chk.style.display = '';
            // if (trk) trk.style.display = 'none';

            /* After last row, flip to results */
            if (i === rows.length - 1) {
              setTimeout(() => {
                setProgress(100);
                setProgressLabel(completeLabel);
                showResults(stepEl);
              }, 700);
            }
          }
        };

        requestAnimationFrame(tick);
      }, i * (FILL_DURATION + ROW_GAP));
    });
  }

  // function showResults(stepEl) {
  //   const analysisPhase = stepEl.querySelector('[data-phase="analysis"]');
  //   const resultsPhase  = stepEl.querySelector('[data-phase="results"]');
  //   if (analysisPhase) analysisPhase.style.display = 'none';
  //   if (resultsPhase)  resultsPhase.style.display  = '';
  //   populateResults();
  //   content.scrollTo({ top: 0, behavior: 'smooth' });
  // }
  function initProductImageSwipers(container) {
    const SwiperCtor = window.Swiper;
    if (!SwiperCtor) return;

    container.querySelectorAll('.lf-result-item.is-visible .product_item_image.swiper').forEach(el => {
      if (el.classList.contains('swiper-initialized')) {
        if (el.swiper) el.swiper.update();
        return;
      }

      new SwiperCtor(el, {
        direction: 'horizontal',
        loop: true,
        effect: 'slide',
        initialSlide: parseInt(el.getAttribute('data-initialSlide'), 10) || 0,
        on: {
          slideChangeTransitionEnd: function () {
            const active = this.el.querySelector('.swiper-slide.swiper-slide-active');
            if (!active) return;
            const variantsMedia = active.getAttribute('data-variants_media');
            if (!variantsMedia || variantsMedia === ' ') return;
            const variantButtons = this.el.closest('.product-item')?.querySelectorAll('.product-item__color-variant');
            if (!variantButtons?.length) return;
            variantButtons.forEach(button => {
              if (variantsMedia.indexOf(button.getAttribute('data-variant-id')) > -1) {
                variantButtons.forEach(b => b.classList.remove('active'));
                button.classList.add('active');
              }
            });
          }
        }
      });
    });
  }

  function showResults(stepEl) {
    const analysisPhase = stepEl.querySelector('[data-phase="analysis"]');
    const resultsPhase  = stepEl.querySelector('[data-phase="results"]');
    if (analysisPhase) analysisPhase.style.display = 'none';
    if (resultsPhase)  resultsPhase.style.display  = '';

    populateResults();
    content.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
      initProductImageSwipers(stepEl);
      window.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));
    }, 50);
  }

  /* ── Product results ────────────────────────────────────────── */
  // function populateResults() {
  //   const grid = finder.querySelector('#lf-product-grid');
  //   if (!grid) return;

  //   const pool   = Array.from(finder.querySelectorAll('#lf-product-pool .lf-pool-item'));
  //   const budget = selectedBudget != null ? selectedBudget : Infinity;
  //   const inCol  = selectedIndoor?.collection  || '';
  //   const outCol = selectedOutdoor?.collection || '';

  //   /* Primary filter: collection match + budget */
  //   let matched = pool.filter(item => {
  //     const price = parseFloat(item.dataset.price);
  //     const cols  = (item.dataset.collections || '')
  //       .split(' ').map(s => s.trim()).filter(Boolean);
  //     const inCollection = (!inCol && !outCol) ||
  //       (inCol  && cols.includes(inCol))  ||
  //       (outCol && cols.includes(outCol));
  //     return inCollection && price <= budget;
  //   });

  //   /* Fallback: if nothing matched, show by budget only */
  //   if (!matched.length) {
  //     matched = pool.filter(item => parseFloat(item.dataset.price) <= budget);
  //   }

  //   matched = matched.slice(0, 6);

  //   if (!matched.length) {
  //     grid.innerHTML = '<p class="lf-no-results">Keine passenden Produkte gefunden.</p>';
  //     return;
  //   }

  //   grid.innerHTML = matched.map(item => {
  //     const price   = parseFloat(item.dataset.price);
  //     const compare = parseFloat(item.dataset.compare);
  //     const hasDiscount = compare > 0 && compare > price;
  //     return `
  //       <a href="${item.dataset.url}" class="lf-product-card">
  //         <div class="lf-product-card__img">
  //           <img src="${item.dataset.image}" alt="${item.dataset.title}" loading="lazy">
  //         </div>
  //         <div class="lf-product-card__info">
  //           <span class="lf-product-card__title">${item.dataset.title}</span>
  //           <div class="lf-product-card__prices">
  //             ${hasDiscount ? `<span class="lf-product-card__compare">${compare}€</span>` : ''}
  //             <span class="lf-product-card__price">${price}€</span>
  //           </div>
  //         </div>
  //       </a>`;
  //   }).join('');
  // }
	function populateResults() {
		const items  = Array.from(finder.querySelectorAll('.lf-result-item'));
		const noRes  = finder.querySelector('.lf-no-results');
		const budget = selectedBudget != null ? selectedBudget : Infinity;
		const inCol  = selectedIndoor?.collection  || '';
		const outCol = selectedOutdoor?.collection || '';

		function setItemVisible(item, visible) {
			item.classList.toggle('is-hidden', !visible);
			item.classList.toggle('is-visible', visible);
			item.style.display = visible ? '' : 'none';
		}

		/* Hide everything first */
		items.forEach(item => setItemVisible(item, false));
		if (noRes) noRes.style.display = 'none';

		/* Primary filter: collection match + budget */
		let matched = items.filter(item => {
			const price = parseFloat(item.dataset.price);
			const cols  = (item.dataset.collections || '')
				.split(' ').map(s => s.trim()).filter(Boolean);
			const inCollection = (!inCol && !outCol) ||
				(inCol  && cols.includes(inCol))  ||
				(outCol && cols.includes(outCol));
			return inCollection && price <= budget;
		});

		/* Fallback: budget only */
		if (!matched.length) {
			matched = items.filter(item => parseFloat(item.dataset.price) <= budget);
		}

		const toShow = matched.slice(0, 6);

		if (toShow.length) {
			toShow.forEach(item => setItemVisible(item, true));
		} else if (noRes) {
			noRes.style.display = '';
		}
	}

  /* ── Slider track fill (CSS custom property) ─────────────────── */
  function updateSliderTrack(slider) {
    const min = +slider.min;
    const max = +slider.max;
    const val = +slider.value;
    const pct = ((val - min) / (max - min)) * 100;
    slider.style.setProperty('--lf-slider-pct', pct + '%');
  }

  /* ── Event delegation ───────────────────────────────────────── */
  finder.addEventListener('click', e => {
    const btn = e.target.closest('[data-action]');
    if (!btn || btn.classList.contains('is-disabled')) return;

    const action = btn.dataset.action;
    const stepEl = btn.closest('.lf-step');
		console.log("This is the action type", action);

    switch (action) {

      /* ── Generic next ── */
      case 'next':
        /* On budget step, capture slider value */
        if (stepEl?.dataset.stepType === 'budget') {
          const sl = stepEl.querySelector('.lf-price-slider');
          if (sl) selectedBudget = +sl.value;
        }
        goNext();
        break;

      /* ── Style card ── */
      case 'select-style':
        stepEl?.querySelectorAll('.lf-style-card').forEach(c => c.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        selectedStyle = { 
					title: btn.dataset.value, 
					imageUrlMobile: btn.dataset.imgMobile || '' 
        };
        setTimeout(goNext, 380);
        break;

      /* ── Mood ❌ / ❤️ ── */
      case 'mood-action': {
        const liked = btn.dataset.liked === 'true';
        if (liked) {
          const title = btn.dataset.moodTitle?.trim();
          if (title && !likedMoods.includes(title)) likedMoods.push(title);
        }
        if (firstMoodHintWrap) return;
        goNext();
        break;
      }

      /* ── Scope card ── */
      case 'select-scope':
        stepEl?.querySelectorAll('.lf-scope-card').forEach(c => c.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        selectedScope = { title: btn.dataset.value, imageUrlMobile: btn.dataset.imgMobile || '' };
        setProgress(+(stepEl?.dataset.progressComplete || 90));
        enableCta(stepEl, true);
        break;

      /* ── Light-type option ── */
      case 'select-lt': {
        const group = btn.dataset.group;
        stepEl?.querySelectorAll('.lf-lt-option').forEach(o => o.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        if (group === 'indoor') {
          selectedIndoor  = { label: btn.dataset.value, collection: btn.dataset.collection || '' };
          selectedOutdoor = null;
        } else {
          selectedOutdoor = { label: btn.dataset.value, collection: btn.dataset.collection || '' };
          selectedIndoor  = null;
        }

        if (selectedIndoor || selectedOutdoor) {
          setProgress(+(stepEl?.dataset.progressComplete || 95));
          enableCta(stepEl, true);
        }
        setTimeout(goNext, 280);
        break;
      }
    }
  });

  /* ── Slider live update ─────────────────────────────────────── */
  finder.addEventListener('input', e => {
    if (!e.target.classList.contains('lf-price-slider')) return;
    const slider = e.target;
    const valEl  = finder.querySelector('#lf-price-current');
    if (valEl) valEl.textContent = slider.value + '€';
    updateSliderTrack(slider);
  });

  /* ── Back button ────────────────────────────────────────────── */
  if (backBtn) backBtn.addEventListener('click', goBack);

  /* ── Initialise first step ──────────────────────────────────── */
  onEnter(getStep(1));

})();
